export const getIsCheckingPricingAvailability = state => state.isCheckingPricingAvailability;
export const getPricingAvailabilityCheckComplete = state => state.pricingAvailabilityCheckComplete;
